export default __webpack_public_path__ + "static/media/img-slider-cmbus-1.b033b842.png";